(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const SERVICE_VARIANT = '49558118531310';
  const ROWS = '.item-cart[data-line], .ajaxcart__product[data-line]';
  const CONTROLS = '.ajaxcart__qty-adjust, .ajaxcart__qty-num, [data-cart-remove], .cart-product-info__btn--remove';
  const CHECKOUT = '[name="checkout"], a[href*="/checkout"], .additional_checkout_buttons, shopify-accelerated-checkout-cart';
  const id = item => String(item.variant_id || item.id || '');
  const isParent = item => !!(item.properties?._ds_engraving_chars || item.properties?._ds_engraving_variant);
  const isFee = item => id(item) === SERVICE_VARIANT;
  function inspectCart(cart) {
    if (!Array.isArray(cart?.items)) return { hasEngraving: true, valid: false, reason: 'configuration' };
    const items = cart.items;
    const parents = items.filter(isParent), fees = items.filter(isFee);
    const hasEngraving = !!(parents.length || fees.length);
    const fail = reason => ({ hasEngraving: true, valid: false, reason });
    if (!hasEngraving) return { hasEngraving: false, valid: true, reason: '' };
    if (cart.currency !== 'USD') return fail('configuration');
    for (const parent of parents) {
      const p = parent.properties, text = String(p.Engraving || '').normalize('NFC');
      let count;
      try { count = [...new Intl.Segmenter('en', { granularity: 'grapheme' }).segment(text)].filter(part => !/^\s+$/u.test(part.segment)).length; }
      catch { return fail('configuration'); }
      if (!count || Array.from(text).length > 200 || String(count) !== p._ds_engraving_chars ||
          p._ds_engraving_variant !== SERVICE_VARIANT || !parent.key || !p._gpo_product_group ||
          !Number.isSafeInteger(parent.quantity) || parent.quantity < 1) return fail('configuration');
      const children = fees.filter(fee => fee.parent_relationship?.parent_key === parent.key);
      if (children.length !== 1) return fail('missing');
      const fee = children[0], f = fee.properties || {};
      if (f.Engraving !== text || f._gpo_parent_product_group !== p._gpo_product_group || f._gpo_per_character !== String(count) ||
          Number(fee.original_price ?? fee.price) !== 1000) return fail('configuration');
      if (fee.quantity !== count * parent.quantity) return fail('quantity');
    }
    if (fees.some(fee => !parents.some(parent => parent.key === fee.parent_relationship?.parent_key))) return fail('missing');
    return { hasEngraving: true, valid: true, reason: '' };
  }
  function install(win) {
    if (win.DSEngravingCart) return;
    const doc = win.document;
    let active = false, busy = 0, epoch = 0, pendingUntil = 0, changedAt = 0, checking = false, approved = false;
    let queued = false;
    const style = doc.createElement('style'); style.id = 'ds-engraving-cart-style';
    style.textContent = '[data-ds-engraving-fee] [hidden]{display:none!important}.ds-engraving-cart-active .additional_checkout_buttons,.ds-engraving-cart-active shopify-accelerated-checkout-cart{display:none!important}.ds-engraving-cart-status{margin:12px 0;font-size:14px;line-height:1.5;color:#263e31}.ds-engraving-cart-count{display:block;font-size:13px;line-height:1.5}';
    doc.head.appendChild(style);
    const now = () => Date.now();
    const delay = ms => new Promise(resolve => win.setTimeout(resolve, ms));
    function activate(cart) {
      if (Array.isArray(cart?.items) && cart.items.some(item => isParent(item) || isFee(item))) active = true;
      if (active) doc.documentElement.classList.add('ds-engraving-cart-active');
    }
    function applicable() {
      activate(win.GPOConfigs?.cart);
      if (!active && doc.querySelector('[data-ds-engraving-fee]')) active = true;
      if (active) doc.documentElement.classList.add('ds-engraving-cart-active');
      return active;
    }
    function setHook(row, prefix, suffix, selector) {
      const node = row.querySelector(selector);
      if (node) node.setAttribute('data-gpo-' + prefix + '-item-' + suffix, '');
    }
    function decorate() {
      queued = false;
      activate(win.GPOConfigs?.cart);
      doc.querySelectorAll(ROWS).forEach(row => {
        const prefix = row.classList.contains('item-cart') ? 'cart' : 'drawer';
        row.setAttribute('data-gpo-' + prefix + '-item-key', row.getAttribute('data-gpo-' + prefix + '-item-key') || row.dataset.line || '');
        setHook(row, prefix, 'image', '.cart-tablet__image, .ajaxcart__product-image');
        setHook(row, prefix, 'details', '.info, .ajaxcart__product-description');
        setHook(row, prefix, 'qty-wrapper', '.cart-product-info__qty, .ajaxcart__qty');
        setHook(row, prefix, 'qty', '.ajaxcart__qty-num');
        setHook(row, prefix, 'qty-decrease', '.ajaxcart__qty--minus');
        setHook(row, prefix, 'qty-increase', '.ajaxcart__qty--plus');
        setHook(row, prefix, 'remove-button', '.cart-product-info__btn--remove, [data-cart-remove]');
        const feeLink = row.querySelector('a[href*="/products/diamond-studio-engraving"]');
        if (feeLink) {
          active = true; doc.documentElement.classList.add('ds-engraving-cart-active'); row.setAttribute('data-ds-engraving-fee', '');
          row.querySelectorAll(CONTROLS).forEach(control => { control.hidden = true; control.setAttribute('aria-hidden', 'true'); control.tabIndex = -1; });
          const qty = row.querySelector('.ajaxcart__qty-num');
          let label = row.querySelector('.ds-engraving-cart-count');
          if (!label && qty) { label = doc.createElement('span'); label.className = 'ds-engraving-cart-count'; qty.closest('.cart-product-info, .drawer__quantity')?.appendChild(label); }
          if (label && qty) { const text = qty.value + ' engraving character' + (Number(qty.value) === 1 ? '' : 's'); if (label.textContent !== text) label.textContent = text; }
        }
      });
    }
    function scheduleDecorate() { if (!queued) { queued = true; win.queueMicrotask(decorate); } }
    function mutationRequest(input, init) {
      try {
        const url = new win.URL(typeof input === 'string' ? input : input.url, win.location.href);
        return url.origin === win.location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(url.pathname) && String(init?.method || input?.method || 'GET').toUpperCase() === 'POST';
      } catch { return false; }
    }
    function started() { busy++; epoch++; pendingUntil = 0; changedAt = now(); let done = false; return () => { if (!done) { done = true; busy--; epoch++; changedAt = now(); scheduleDecorate(); } }; }
    // Observe completion without changing either the app's payload or its response.
    const originalFetch = win.fetch;
    win.fetch = function (input, init) {
      if (!mutationRequest(input, init)) return originalFetch.call(this, input, init);
      const finish = started();
      let response;
      try { response = originalFetch.call(this, input, init); } catch (error) { finish(); throw error; }
      return Promise.resolve(response).then(async result => {
        try { activate(await result.clone().json()); } catch (_) {}
        return result;
      }).finally(finish);
    };
    if (win.XMLHttpRequest) {
      const proto = win.XMLHttpRequest.prototype, open = proto.open, send = proto.send, requests = new WeakMap();
      proto.open = function (method, url) { requests.set(this, { method, url: new win.URL(String(url), win.location.href).href }); return open.apply(this, arguments); };
      proto.send = function () {
        const meta = requests.get(this);
        if (!meta || !mutationRequest(meta, { method: meta.method })) return send.apply(this, arguments);
        const finish = started();
        this.addEventListener('loadend', () => { try { if (!this.responseType || this.responseType === 'text') activate(JSON.parse(this.responseText)); } catch (_) {} finish(); }, { once: true });
        try { return send.apply(this, arguments); } catch (error) { finish(); throw error; }
      };
    }
    function status(target, message, failure) {
      const region = target?.closest?.('.cart-total, .ajaxcart__footer, form') || doc.querySelector('#cart-form') || doc.body;
      let node = region.querySelector('.ds-engraving-cart-status');
      if (!node) { node = doc.createElement('p'); node.className = 'ds-engraving-cart-status'; node.setAttribute('role', 'status'); region.appendChild(node); }
      node.textContent = message; node.setAttribute('role', failure ? 'alert' : 'status'); node.hidden = !message;
    }
    function inProgress() {
      const gpo = win.GPOConfigs;
      return busy > 0 || now() < pendingUntil || now() - changedAt < 300 || !!(gpo?.cartSyncPromise || gpo?.cartDrawerSyncPromise || gpo?.cartReconcilePromise);
    }
    async function settle() {
      const end = now() + 12000;
      while (inProgress()) { if (now() >= end) throw new Error('Your bag is still updating. Wait a moment, then try checkout again.'); await delay(80); }
    }
    function locked() {
      const controls = [...doc.querySelectorAll(ROWS + ', [name="checkout"]')].flatMap(node => node.matches(ROWS) ? [...node.querySelectorAll('input,button,select')] : [node]);
      const changed = controls.filter(control => !control.disabled);
      changed.forEach(control => { control.disabled = true; });
      return () => changed.forEach(control => { if (control.isConnected) control.disabled = false; });
    }
    async function check(target, replay) {
      if (checking) return;
      checking = true;
      const restore = locked();
      status(target, 'Checking your engraving…', false);
      try {
        await settle();
        const before = epoch;
        const response = await originalFetch.call(win, (win.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('We could not check your engraving. Please try checkout again.');
        const cart = await response.json(); activate(cart);
        if (!Array.isArray(cart?.items) || typeof cart.currency !== 'string') throw new Error('We could not check your engraving. Please try checkout again.');
        if (epoch !== before || inProgress()) throw new Error('Your bag is still updating. Wait a moment, then try checkout again.');
        const result = inspectCart(cart);
        if (!result.valid) throw new Error(result.reason === 'quantity' ? 'Your bag is still updating. Wait a moment, then try checkout again.' : 'Your engraving charge needs to be refreshed. Remove this piece from your bag and add it again with your engraving.');
        for (const row of target?.closest?.('form')?.querySelectorAll(ROWS) || []) {
          const input = row.querySelector('.ajaxcart__qty-num');
          const key = input?.dataset.id || row.getAttribute('data-gpo-cart-item-key') || row.getAttribute('data-gpo-drawer-item-key');
          const item = key && key !== row.dataset.line ? cart.items.find(item => item.key === key) : cart.items[Number(row.dataset.line) - 1];
          if (input && (!item || Number(input.value) !== item.quantity)) throw new Error('Your bag is still updating. Wait a moment, then try checkout again.');
        }
        status(target, '', false); restore(); approved = true;
        try { replay(); } finally { approved = false; }
      } catch (error) { status(target, error.message || 'We could not check your engraving. Please try checkout again.', true); }
      finally { restore(); checking = false; }
    }
    doc.addEventListener('click', event => {
      const control = event.target?.closest?.(CONTROLS);
      if (control?.closest(ROWS)) {
        if (control.closest('[data-ds-engraving-fee]') || checking) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        if (applicable()) pendingUntil = now() + 700;
      }
      const target = event.target?.closest?.(CHECKOUT);
      if (!target || approved || !applicable()) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const form = target.closest('form'), accelerated = target.matches('.additional_checkout_buttons, shopify-accelerated-checkout-cart') || !!target.closest('.additional_checkout_buttons');
      const button = accelerated ? form?.querySelector('[name="checkout"]') : target;
      check(target, () => { if (button?.isConnected) button.click(); else if (form) form.requestSubmit(); });
    }, true);
    doc.addEventListener('change', event => {
      const control = event.target?.closest?.(CONTROLS);
      if (!control?.closest(ROWS)) return;
      if (control.closest('[data-ds-engraving-fee]') || checking) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (applicable()) pendingUntil = now() + 700;
    }, true);
    doc.addEventListener('submit', event => {
      if (approved || event.submitter?.name !== 'checkout' || !applicable()) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const form = event.target, submitter = event.submitter;
      check(submitter, () => form.requestSubmit(submitter?.isConnected ? submitter : undefined));
    }, true);
    function start() {
      decorate();
      new win.MutationObserver(scheduleDecorate).observe(doc.body, { childList: true, subtree: true });
    }
    win.DSEngravingCart = { inspectCart, decorate, get state() { return { active, busy, checking }; } };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  }
  return { inspectCart, install };
});

